import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FullPageProgress from "../../../FullPageProgress";
import { ToastManager } from "../../../Toast/ToastManager";
import SetupHeader from "../SetupHeader";
import SendgrindDomain from "./SendgrindDomain";
import SendgrindReview from "./SendgrindReview";
import SendgrindVerify from "./SendgrindVerify";
import { SESSION_AUTH } from "../../../../common/auth";
import { isValidEmail } from "../../../../common/utils";
import { SENDGRID_SERVICES } from "../../../../services";
import "./style.scss";

const SetupSendgrid = () => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [email, setEmail] = useState("");
  const [emailUserName, setEmailUserName] = useState("");
  const [emailDomain, setEmailDomain] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [verifyData, setVerifyData] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [userData, setUserData] = useState("");

  useEffect(() => {
    if (isUserSession) {
      setUserData(isUserSession);
    } else {
      setUserData("");
    }
  }, [isUserSession]);

  const onClose = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const continueUrl = queryParameters.get("continueUrl");
    navigate(continueUrl || "/", { replace: true });
  };

  const onStep = s => {
    if (s) {
      setCurrentStep(s);
    }
  };

  const onDomainNext = () => {
    if (!email || (email && !isValidEmail(email))) {
      ToastManager.addToast({
        title: "Please enter a valid email address.",
      });
      return;
    }
    const [name, domain] = email.split("@");
    if (name && domain) {
      setEmailUserName(name);
      setEmailDomain(domain);
      onStep(2);
    } else {
      ToastManager.addToast({
        title: "Please enter a valid email address.",
      });
    }
  };

  const onReviewNext = () => {
    if (!email || (email && !isValidEmail(email))) {
      ToastManager.addToast({
        title: "Please enter a valid email address.",
      });
      onStep(1);
      return;
    }
    setLoading(true);
    SENDGRID_SERVICES.domainAuth({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      email: email,
    })
      .then(data => {
        if (data.code === 200) {
          setCurrentStep(3);
          setVerifyData(data?.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!userData || dataFetched) return;
    setDataFetched(true);
    setLoading(true);
    SENDGRID_SERVICES.overview({
      userId: userData.userId,
      org: userData?.org?.id,
    })
      .then(data => {
        if (data.code === 200) {
          setVerifyData(data?.data);
          setCurrentStep(3);
        } else if (data.code === 201) {
          setCurrentStep(1);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        // dataFetched.current = false;
        setLoading(false);
      });
  }, [userData, LOGOUT_USER_SESSION, dataFetched]);

  const onValidate = () => {
    setLoading(true);
    SENDGRID_SERVICES.validate({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
    })
      .then(data => {
        if (data.code === 200 || data.code === 201) {
          setDataFetched(false);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return currentStep ? (
    <div className="events-page-setup-steps">
      {loading ? <FullPageProgress fixed={true} /> : null}
      <SetupHeader
        currentStep={currentStep}
        totalStep={[1, 2, 3]}
        onClose={onClose}
      />
      {currentStep === 1 ? (
        <SendgrindDomain
          email={email}
          setEmail={setEmail}
          onNext={onDomainNext}
        />
      ) : currentStep === 2 ? (
        <SendgrindReview
          emailUserName={emailUserName}
          emailDomain={emailDomain}
          onNext={onReviewNext}
          onStep={onStep}
        />
      ) : currentStep === 3 ? (
        <SendgrindVerify
          verifyData={verifyData}
          onClose={onClose}
          onValidate={onValidate}
        />
      ) : null}
    </div>
  ) : (
    <FullPageProgress fixed={true} />
  );
};

export default SetupSendgrid;
